

<template>
  <transition name="fade">
    <div class="please-wait d-flex flex-column justify-content-center align-items-center">
      <div class="heart-rate">
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="150px"
          height="73px"
          viewBox="0 0 150 73"
          enable-background="new 0 0 150 73"
          xml:space="preserve"
        >
          <polyline
            fill="none"
            stroke="#ff9817"
            stroke-width="3"
            stroke-miterlimit="10"
            points="0,45.486 38.514,45.486 44.595,33.324 50.676,45.486 57.771,45.486 62.838,55.622 71.959,9 80.067,63.729 84.122,45.486 97.297,45.486 103.379,40.419 110.473,45.486 150,45.486"
          />
        </svg>
        <div class="fade-in" :style="fadeInBGColour"></div>
        <div class="fade-out" :style="fadeOutBGColour"></div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    bgColour: {
      type: String,
      default: "#F8F9FA"
    },
  },
  name: "PleaseWait",
  methods: {},
  beforeMount() {},
  computed:{
    fadeInBGColour() { return "background-color: " + this.bgColour + "FF"; },
    fadeOutBGColour() { 
      return  "background-color: " + this.bgColour + "FF"
            + "background: " + this.bgColour + "FF"
            + "background: -moz-linear-gradient("
            + "  left,"
            + "  " + this.bgColour + "FF 0%,"
            + "  " + this.bgColour + "FF 50%,"
            + "  " + this.bgColour + "00 100%"
            + ");"
            + "background: -webkit-linear-gradient("
            + "  left,"
            + "  " + this.bgColour + "FF 0%,"
            + "  " + this.bgColour + "FF 50%,"
            + "  " + this.bgColour + "00 100%"
            + ");"
            + "background: -o-linear-gradient("
            + "  left,"
            + "  " + this.bgColour + "FF 0%,"
            + "  " + this.bgColour + "FF 50%,"
            + "  " + this.bgColour + "00 100%"
            + ");"
            + "background: -ms-linear-gradient("
            + "  left,"
            + "  " + this.bgColour + "FF 0%,"
            + "  " + this.bgColour + "FF 50%,"
            + "  " + this.bgColour + "00 100%"
            + ");"
            + "background: linear-gradient("
            + "  to right,"
            + "  " + this.bgColour + "FF 0%,"
            + "  " + this.bgColour + "FF 80%,"
            + "  " + this.bgColour + "00 100%"
            + ");";
    }
  }
};
</script>

<style scoped>
.please-wait {
  opacity: 1;
  /*z-index: -10;*/
}

.please-wait h5 {
  max-width: 40%;
  text-align: center;
  font-style: italic;
}

.please-wait img {
  width: 20%;
  height: auto;
}

.heart-rate {
  position: relative;
}

.fade-in {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  animation: heartRateIn 1s linear infinite;
}

.fade-out {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  animation: heartRateOut 1s linear infinite;
}

@keyframes heartRateIn {
  0% {
    width: 100%;
  }
  50% {
    width: 0;
  }
  100% {
    width: 0;
  }
}

@keyframes heartRateOut {
  0% {
    left: -100%;
  }
  30% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}
</style>
